import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '@hooks/useData';

export const useVerifyAccess = (requiredRole: string) => {
    const navigate = useNavigate();
    const { user } = useData();

    useEffect(() => {
        if (!user) return;

        if (user?.data?.user_type !== requiredRole) {
            navigate('/unauthorized', { replace: true });
        }
    }, [user, navigate, requiredRole]);
};


export const useDriverAccess = () => useVerifyAccess('Driver');
export const useRiderAccess = () => useVerifyAccess('Rider');